/**
 * Calculate years of experience based on a start date
 * @param startYear - The year when experience started
 * @param startMonth - The month when experience started (1-12)
 * @returns String in format "X+" where X is the number of years
 */
export const calculateYearsOfExperience = (
  startYear: number = 2018,
  startMonth: number = 8, // August
): string => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11

  let years = currentYear - startYear;

  // If we haven't reached the anniversary month yet this year, subtract 1
  if (currentMonth < startMonth) {
    years -= 1;
  }

  return `${years}+`;
};

/**
 * Get the current years of experience as a number
 * Used for calculations or comparisons
 */
export const getYearsOfExperience = (startYear: number = 2018, startMonth: number = 8): number => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  let years = currentYear - startYear;

  if (currentMonth < startMonth) {
    years -= 1;
  }

  return years;
};
